<form class="needs-validation" [formGroup]="myForm" novalidate>
      <app-validation-banner [form]="myForm" [show]="showBanner"></app-validation-banner>
    <app-form-base [myForm]="myForm" [request]="request" [duplicated]="duplicated" (newModel)="updateRequest($event)" (newFile)="updateFile($event)" [group]="GROUP" (newOptFile)="updateOptFile($event)" ></app-form-base>
    <label for ="description"> <p class="bold pad-left no-pad">Request Details</p></label>
 <p class="no-pad pad-left">Please be specific about your request.</p>
 <div class = "text-pad">
 <textarea class="col-12  fit" maxlength="5000" id="description" formControlName = "requestDetails" rows="10">

</textarea>
</div>
<p class="err pad-left" *ngIf="myForm.controls.requestDetails.errors?.required && myForm.controls.requestDetails.touched">
   Request Details are required
</p>
<p class="no-pad gray pad-left">{{myForm.controls['requestDetails'].value.length}} of 5,000 characters</p>
<div class="col-md-7 mb-3">
   <label for="reasonForResignation" class="marg-left">Reason for Resignation</label>
   <select class="custom-select marg-left" id="reasonForResignation" formControlName = "reasonForResignation">
      <option selected disabled value="">- Select -</option>
      <option *ngFor="let enum of resign | keyvalue: valueAscOrder" [value]="[(enum.value)]">
         {{ enum.value | capital}}
      </option>
   </select>
   <p class="err pad-left" *ngIf="myForm.controls.reasonForResignation.errors?.required && myForm.controls.reasonForResignation.touched">
      Reason for Resignation is required
   </p>
</div>
<label class="bold pad-left">
   Attach Letter
</label>
<p class = "no-pad pad-left">We require a signed letter printed on your company letterhead to process resignations.</p>
<app-file-upload [myForm]="myForm" [doc]="doc" (newFile)="updateFile($event)"></app-file-upload>
<label class="bold pad-left">Attach Document 
   <span class="optional-tag no-bold"> (optional)</span>
</label> 
<p class = "no-pad pad-left">If you have additional documents you would like to upload you can do so here.</p>
    <app-opt-file-upload [myForm]="myForm" *ngIf="optDocs" [optDocs]="optDocs"  (newOptFile)="updateOptFile($event)"> </app-opt-file-upload>
 </form>
 <app-add-request-button [group]="GROUP" [reqType]="reqToggle" [validated]= "myForm.touched" (close)="closeParent($event)" (submit)="submit($event)"></app-add-request-button>


 
